import React, { useCallback, useState } from 'react';
import { CrmActivityTypeButton } from '../CrmActivityTypeButton/CrmActivityTypeButton';
import { CreateActivityModal } from '../CreateActivityModal/CreateActivityModal';
import { ECrmActivityType } from 'services/CrmApi/types/CrmActivityTypes';
import { ECrmDirectoryEntryType } from 'services/CrmApi/types/DirectoryEntry';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { useCanEditEntry } from 'containers/CRM/hooks/useCanEdit';

interface IActivityButtonsProps {
  directoryEntryId: string;
  directoryEntryType: ECrmDirectoryEntryType;
  onCreateActivity: () => void;
}

export const ActivityButtons: React.FC<IActivityButtonsProps> = ({
  directoryEntryId,
  directoryEntryType,
  onCreateActivity,
}) => {
  const { dynamicParameters } = useDynamicParameters();
  const canCreateActivities = useCanEditEntry(directoryEntryId, directoryEntryType);
  const [activityModalType, setActivityModalType] = useState<ECrmActivityType | null>(null);
  const handleModalClose = useCallback(() => {
    setActivityModalType(null);
  }, []);

  const handleCallButton = useCallback(() => {
    setActivityModalType(ECrmActivityType.CALL);
  }, []);

  const handleMeetingButton = useCallback(() => {
    setActivityModalType(ECrmActivityType.MEETING);
  }, []);

  const handleNoteButton = useCallback(() => {
    setActivityModalType(ECrmActivityType.NOTE);
  }, []);

  const handleTaskButton = useCallback(() => {
    // remove this check when CRM_TMS is deprecated
    if (!dynamicParameters.ENABLE_CRM_TMS) {
      console.log('CRM_TMS is not enabled');
      return;
    }
    
    window.open(`/tasks/create?openedBy=${directoryEntryId}`, '_blank');
  }, []);

  return (
    <div className="flex flex-row-reverse justify-end md:justify-start">
      <div className="activity-buttons flex gap-[20px]">
        <CrmActivityTypeButton type={ECrmActivityType.CALL} onClick={handleCallButton} disabled={!canCreateActivities} />
        <CrmActivityTypeButton type={ECrmActivityType.MEETING} onClick={handleMeetingButton} disabled={!canCreateActivities} />
        <CrmActivityTypeButton type={ECrmActivityType.NOTE} onClick={handleNoteButton} disabled={!canCreateActivities} />
        <CrmActivityTypeButton
          type={ECrmActivityType.TASK}
          onClick={handleTaskButton}
          disabled={!canCreateActivities || !dynamicParameters.ENABLE_CRM_TMS}
        />

        {activityModalType && (
          <CreateActivityModal
            type={activityModalType}
            directoryEntryId={directoryEntryId}
            directoryEntryType={directoryEntryType}
            onSuccess={onCreateActivity}
            onClose={handleModalClose}
          />
        )}
      </div>
    </div>
  );
};
